export interface IPaginateTable {
  pageNum: number;
  pageSize: number;
}

export interface IOptionPaginateTable {
  title?: string;
  numberRecordShow: number;
  totalRecord: number;
  pageNum: number;
  pageSize: number;
  onChangePageNum: (page: number, pageSize: number) => void;
  onShowSizeChange?: (current: number, size: number) => void;
}

export interface IBaseDataOutputModel<T> {
  data: T;
  statusCode: number;
}

export interface IBaseDataForPaginate<T> extends IBaseDataOutputModel<T[]> {
  meta: {
    totalRecords: number;
    pageNum: number;
    totalPages: number;
  };
}

export enum EStatusCountTable {
  TOTAL = "total",
  SHOW = "show",
  NO_SHOW = "noShow",
}

export interface IGetTotalOutputModel {
  total: number;
  show: number;
  noShow: number;
}

export interface ICountTable {
  key: string;
  name: string;
  count: number;
}

export interface IBaseGetDataForPaginate {
  filter?: object;
  sortBy: "createdAt" | "updatedAt" | string;
  sortOrder: "desc" | "asc";
  pageSize?: string | number;
  pageNum?: string | number;
}
